// Retrive creators name from YouTube video ID using YouTube V3 Data API
// Genrate API key URL: https://console.cloud.google.com/apis/credentials?project=test-load-creator-name-youtube&supportedpurview=project

const apiKey = ""; // Replace with your YouTube API key
const videoId = ""; // Replace with the actual YouTube video ID

const apiUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${apiKey}`;
console.log("apiUrl :", apiUrl);
fetch(apiUrl)
  .then((response) => response.json())
  .then((data) => {
    const video = data.items[0];
    const creatorName = video.snippet.channelTitle;

    // Now you can use the 'creatorName' variable as needed.
    console.log("Creator Name:", creatorName);
    console.log("data:", data);
    console.log("video.snippet:", video.snippet);
  })
  .catch((error) => {
    console.error("Error fetching data:", error);
  });
